const HEX_COLOR_PATTERN = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export const isValidHexColor = (color: string): boolean => HEX_COLOR_PATTERN.test(color);

export const toSixDigitHex = (color: string): string => {
  const normalized = color.toLowerCase();
  if (normalized.length === 4) {
    const [, r, g, b] = normalized;
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return normalized;
};
